export default function Progress({ status, end, current, children, format }) {
  function calculatePercentage(part, total) {
    if (total <= 0) return "0.00%";
    const percentage = Math.min(100, Math.max(0, (part / total) * 100));
    return `${percentage.toFixed(2)}%`;
  }

  return (
    <div className="w-full">
      <h4 className="sr-only">{status}</h4>
      <div className="flex w-full">
        <p className="font-semibold">{status}</p>
        <p className="ml-auto text-sm text-zinc-500">
          {calculatePercentage(current, end)}
        </p>
      </div>
      <div aria-hidden="true" className="mt-6">
        <div className="overflow-hidden rounded-full bg-zinc-200">
          <div
            style={{ width: calculatePercentage(current, end) }}
            className="h-2 rounded-full bg-emerald-600"
          />
        </div>
        {children && <div className="mt-6">{children}</div>}
      </div>
    </div>
  );
}
